import React, {useEffect, useState} from "react";
import DrawerProductFilters from "./DrawerProductFilters";
import InlineProductFilters from "./InlineProductFilters";
import {useMediaQuery} from "react-responsive";
import * as ReactDOM from "react-dom";

export const RESPONSIVE_MODE = "responsive";
export const DRAWER_MODE = "drawer";
export const INLINE_MODE = "inline";
const FILTERS_PORTAL_DIV = "filters-drawer";

function ProductFilters({mode = RESPONSIVE_MODE, ...props}) {
  const [container, setContainer] = useState();
  useEffect(() => {
    setContainer(document.getElementById(FILTERS_PORTAL_DIV));
  }, [setContainer]);

  const isMobile = useMediaQuery({maxWidth: 1023});

  switch (mode) {
    case RESPONSIVE_MODE:
      if (isMobile) {
        return container ? (
          ReactDOM.createPortal(<DrawerProductFilters {...props} />, container)
        ) : (
          <div />
        );
      } else {
        return <InlineProductFilters {...props} />;
      }
    case DRAWER_MODE:
      return container ? (
        ReactDOM.createPortal(<DrawerProductFilters {...props} />, container)
      ) : (
        <div />
      );
    case INLINE_MODE:
      return <InlineProductFilters {...props} />;
    default:
      throw new Error("Invalid product filters mode");
  }
}

export default ProductFilters;
